/* eslint-disable import/extensions */
import { IdleQueue } from 'idlize/IdleQueue.mjs'

import tracker from '@titanio/tracker'
import ThirdParty from '@titanio/thirdparty'
import animation from '@modules/animation'
import Async3rdLoad from '@titanio/async-3rd-loader'

import leadTracking from '@modules/lead-tracking'
// eslint-disable-next-line import/no-extraneous-dependencies
import header from '../components/header/header'
import expandableContent from '../components/expandable-content/expandable-content'

const loader = () => {
  const queue = new IdleQueue()

  setTimeout(() => tracker.mount(), 0)

  setTimeout(() => {
    header.mount()
  }, 0)

  setTimeout(() => animation.mount(), 0)
  setTimeout(() => expandableContent.mount(), 0)

  queue.pushTask(() => {
    leadTracking.mount()
  })

  window.LazyLoad = ThirdParty
  window.AsyncModule = Async3rdLoad
}

export default { loader }
